<template>
  <div>
    <template v-if="loggedIn">
      <AccountInfo />
    </template>
    <template v-else>
      <h3>{{ $t("formulaireAuth.connexion") }}</h3>
      <div>
        <p>{{ $t("formulaireAuth.sousTitre") }}</p>
        <v-form ref="authForm">
          <v-text-field v-model="credentials.numero" outlined :rules="required" :disabled="loginLoading" :loading="loginLoading">
            <template v-slot:label>{{ $t("formulaireAuth.numero") }} *</template>
          </v-text-field>
          <v-text-field
            v-model="credentials.codePostal"
            outlined
            v-facade="'A#A #A#'"
            :rules="codePostalRules"
            :disabled="loginLoading"
            :loading="loginLoading"
          >
            <template v-slot:label>{{ $t("formulaireAuth.codePostal") }} *</template>
          </v-text-field>
        </v-form>

        <div class="text-center">
          <v-btn color="primary" @click="login" large :disabled="loginLoading" :loading="loginLoading">{{ $t("formulaireAuth.seConnecter") }}</v-btn>
        </div>

        <v-alert v-if="loginError" type="error" border="left" text class="mt-3">{{ $t("formulaireAuth.unauthorizedMessage") }}</v-alert>
      </div>
    </template>
  </div>
</template>

<script>
import Auth from "@/mixins/Auth"
import Rules from "@/mixins/Rules"
import AccountInfo from "@/components/common/AccountInfo"
export default {
  mixins: [Auth, Rules],
  components: { AccountInfo }
}
</script>

<style>
</style>